import { motion, useAnimation } from 'motion/react';
import React, { PropsWithChildren, useEffect } from 'react';

export const SafeMotionUl = React.forwardRef<
  HTMLUListElement,
  PropsWithChildren<any>
>(({ children, ...props }, ref) => {
  const controls = useAnimation();

  useEffect(() => {
    return () => {
      controls.stop();
    };
  }, [controls]);

  return (
    <motion.ul ref={ref} animate={controls} {...props}>
      {children}
    </motion.ul>
  );
});
